module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b5fJv"))).then(() => parcelRequire('37nVf'));